export const IPCC_FORMAT = [
  {
    value: 'default',
    label: 'Default',
  },
  {
    value: 'ar4',
    label: 'AR4 ',
  },
  {
    value: 'ar5',
    label: 'AR5',
  },
];
